import { render } from "./Introduce.vue?vue&type=template&id=3a5329b3&scoped=true"
import script from "./Introduce.vue?vue&type=script&lang=js"
export * from "./Introduce.vue?vue&type=script&lang=js"

import "./Introduce.vue?vue&type=style&index=0&id=3a5329b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5329b3"]])

export default __exports__